import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import editRecommendationCategoryDialog from './dialog.editRecommendationCategoryDialog';
import controller from './recommendation-categories.controller';
import directive from './recommendation-categories.directive';
import recommendationCategory from './recommendationCategory';


export default angular.module('app.components.advisory.auditTrail.recommendationCategories', [
  alerts,
  amDataService,
  amSharedModelService,
  constants,
  editRecommendationCategoryDialog,
  recommendationCategory,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amRecommendationCategories', directive)
  .controller('RecommendationCategoriesController', controller)
  .name;

console.log('app.components.advisory.auditTrail.recommendationCategories created');
